export const REPORT_UPLOAD_ROLES = [
  "super_admin",
  "admin",
  "sleep_technician",
  "sale",
  "accountant",
];

export const canUploadPatientReport = (roles = []) =>
  Array.isArray(roles) &&
  roles.some((role) => REPORT_UPLOAD_ROLES.includes(role));

const legacyDeleteBlockedRoles = [
  "sale",
  "accountant",
  "staff",
  "sleep_technician",
];

export const canDeletePatientReport = (roles = []) => {
  if (!Array.isArray(roles) || roles.length === 0) {
    return false;
  }

  return (
    roles.includes("sale") ||
    roles.includes("accountant") ||
    !legacyDeleteBlockedRoles.includes(roles[0])
  );
};
